import type { OrderInput } from '../types/kalshi';
export interface DeskResolutionPlan {
  id:string; ticker:string; expiresInSeconds:number;
  orders:{id:string;own:boolean;remaining:number}[];
}
export class DeskResolutionConfirmation extends Error {
  constructor(public plan:DeskResolutionPlan,public input:OrderInput) {super('Review the opposite-side orders before cancelling.');}
}
